import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Users } from "lucide-react";
import { api } from "@/lib/api";

export const ReferralCard = ({ sessionId }) => {
  const [ref, setRef] = useState(null);
  useEffect(() => {
    if (!sessionId) return;
    api.get("/player/referral", { params: { session_id: sessionId } }).then((r) => setRef(r.data)).catch(() => {});
  }, [sessionId]);
  if (!ref) return null;
  const link = `${window.location.origin}/?ref=${ref.code}`;
  const copy = async () => {
    try { await navigator.clipboard.writeText(link); toast.success("Invite link copied"); } catch { toast(link); }
  };
  const share = () => (navigator.share ? navigator.share({ title: "Naevo Casino", text: "Play real Deriv games with me on Naevo Casino", url: link }).catch(() => {}) : copy());

  return (
    <section className="casino-frame rounded-2xl p-5 sm:p-6" data-testid="referral-card">
      <div className="flex items-center justify-between gap-3 flex-wrap">
        <div className="flex items-center gap-2"><Users className="h-5 w-5 text-gold" /><h3 className="font-casino text-xl text-gold-grad">Invite friends</h3></div>
        <div className="font-mono-naevo text-sm text-white/70" data-testid="referral-joined"><span className="text-gold text-lg">{ref.joined}</span> friends joined</div>
      </div>
      <div className="mt-4 flex flex-col sm:flex-row gap-2">
        <div className="flex-1 rounded-full border border-gold/30 bg-black/50 px-4 py-2.5 font-mono-naevo text-xs text-white/80 truncate" data-testid="referral-link">{link}</div>
        <div className="flex gap-2">
          <button onClick={copy} className="btn-ghost rounded-full px-4 py-2.5 text-sm flex items-center gap-2" data-testid="referral-copy-btn"><Copy className="h-4 w-4" /> Copy</button>
          <button onClick={share} className="btn-gold rounded-full px-5 py-2.5 text-sm" data-testid="referral-share-btn">Share</button>
        </div>
      </div>
    </section>
  );
};
